// Campaign URL generation utility (frontend)
export function generateCampaignURL(campaign: any, baseUrl: string): string {
  // Use shortCode if available, otherwise fall back to code
  const ref = campaign.shortCode || campaign.code;
  return `${baseUrl}/?ref=${ref}`;
}
